// src/modules/Rules/adapters/PaymentMethodsApiAdapter.ts
import { HttpClient } from '@adapters/HttpClient';
import type { Option } from './ConditionApiAdapter';

export class PaymentMethodsApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getAll(): Promise<Option[]> {
    const raw = await this.httpClient.get<any>('/payment-methods');
    // Normalizamos por si acaso viene envuelto en { data: [...] }
    const list = Array.isArray(raw) ? raw : (raw.data ?? []);
    return list.map((m: any) => ({
      id: String(m.id),
      name: m.method,
    }));
  }
}
